import CookiesJS from './libs/cookies.js';


function MainCookiesScript() {

    const self = this;
    const default_lang_code = 'en';

    function generateUrl(path) {
        let url = 'https://join-dev.com' + path;
        if (window.location.hostname == 'join.com') {
            url = 'https://join.com' + path;
        } else if (window.location.hostname == 'join-staging.com') {
            url = 'https://join-staging.com' + path;
        }

        return url;
    }

    function construct_join_lang_cookie(lang_code) {
        let code_join = 'de-de';
        if (lang_code == 'en') {
            code_join = 'en-us';
        }
        if (['fr', 'nl', 'es'].includes(lang_code)) {
            code_join = `${lang_code}-${lang_code}`;
        }
        return code_join;
    }

    function initFirstVisit() {
        let code_join = self.cookies.getCookie('locale');
        if (!code_join) {
            let lang_code = document.documentElement.lang;
            let code_join = construct_join_lang_cookie(lang_code);
            self.cookies.setCookie('locale', code_join, 365);
        }
    }

    function initRegularVisit() {
        if (window.location !== window.parent.location) {
            return;
        }
        let code_join = self.cookies.getCookie('locale');
        if (code_join) {
            let lang_code = document.documentElement.lang;
            let current_code_join = construct_join_lang_cookie(lang_code);
            if (code_join != current_code_join) {
                self.cookies.setCookie('locale', current_code_join, 365);
            }
        }
    }

    function initSwitcher() {
        for (let link of document.querySelectorAll('.lswitcher .lswitcher_list_link')) {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                let lang_code = link.getAttribute('data-code');
                if (!lang_code) {
                    lang_code = default_lang_code;
                }
                let code_join = construct_join_lang_cookie(lang_code);
                self.cookies.setCookie('locale', code_join, 365);
                setTimeout(() => {
                    window.location.href = link.href;
                }, 100);
            });
        }
    }

    function toggle_user_data(user_data) {
        toggleUserLogin();
        if (!user_data || !user_data.hasOwnProperty('type')) {
            return;
        }
        if (user_data.type == 'candidate') {
            document.querySelector('.user_dashboard_btn').href = generateUrl('/candidate');
        }
        if (user_data.type === 'user') {
            const statsig_user = {
              userID:
                window.location.hostname == "join-staging.com"
                  ? `staging-${user_data.id}`
                  : user_data.id,
              email: user_data.email,
              customIDs: {},
            };
            const statsig_stable_id = self.cookies.getCookie("statsig-stable-id");
            if (statsig_stable_id) {
              statsig_user.customIDs.stableID = statsig_stable_id;
            }

            window.statsig_user = statsig_user;
            if (window.Statsig) {
                window.Statsig.instance().updateUserSync(statsig_user);
            }
        }

        window.dataLayer.push({
          event: 'identity',
          userId: user_data.id,
          companyId: user_data.companyId,
        })
    }

    function initAuth() {
        let raw_auth = localStorage.getItem('auth');
        if (!raw_auth) {
            toggleUserLogout();
            return;
        }

        fetch(generateUrl('/api/identity'))
            .then(response => {
                if (response.status == 200) {
                    return response.json();
                }
                return false;
            }).then(data => {
                if (data) {
                    toggle_user_data(data);        
                } else {
                    localStorage.removeItem('auth');
                    toggleUserLogout();
                }
        }).catch(() => {
            localStorage.removeItem('auth');
            toggleUserLogout();
        })
    }

    function initLogOutBtn() {
        let btn = document.getElementById('user-logout-btn');
        if (!btn) {
            return;
        }
        btn.addEventListener('click', function() {
            document.cookie = 'fcaid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'fccid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'fcuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'fcpmuc' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            localStorage.removeItem('auth');

            fetch(generateUrl('/api/token'), {
                method: 'DELETE'
            }).then(() => {
                toggleUserLogout();
            });
        });
    }


    function toggleUserLogin() {
        document.body.classList.add('is-login');
        document.body.classList.remove('is-anonymous');
    }


    function toggleUserLogout() {
        document.body.classList.remove('is-login');
        document.body.classList.add('is-anonymous');
    }

    function initCookiesScripts() {
        function initCookiesScriptsF() {
            initFirstVisit();
        }
        if (
            window.location.hostname == 'join.com' ||
            window.location.hostname == 'join-staging.com'
        ) {
            window.addEventListener('CookieScriptAcceptAll', initCookiesScriptsF, false);
            window.addEventListener('CookieScriptAccept', initCookiesScriptsF, false);
            window.addEventListener('CookieScriptReject', initCookiesScriptsF, false);
        }
    }


    self.run = function() {
        self.cookies = new CookiesJS();
        initAuth();
        initSwitcher();
        initLogOutBtn();
        initCookiesScripts();
        initRegularVisit();
    }


}


const join_cookies_js = new MainCookiesScript();
join_cookies_js.run();
